import {
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Link,
  Backdrop,
  CircularProgress,
  Typography,
  Rating,
} from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import Typewriter from "typewriter-effect";
import { Box, styled } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Logo from "../../Analysis/Assets/Logo/logo2.svg";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import LineGraph from "../../Analysis/components/LineGraph";
import FooterNew from "../../Home/components/Footer/FooterNew";
import TopicAnalysis from "../components/TopicAnalysis";
import { useAnalysisGetMutation } from "../../app/services/quizCore";
import CompanySlider from "../../Analysis/components/CompanySlider";
import PieChart from "../components/PieChart";
import Banner from "../components/Banner";
import { ToastContainer, toast } from "react-toastify";

const CardContents = styled(CardContent)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  color: "#F4F4FF",
  minHeight: "25rem",
  maxHeight: "25rem",
  padding: "2rem",
});

const CardContentsMobile = styled(CardContent)({
  color: "#F4F4FF",
  padding: "2rem",
  minHeight: "30rem",
  maxHeight: "30rem",
});

const packages = {
  0: "Unplaced",
  1: "3 - 5 LPA",
  2: "5 - 10 LPA",
  3: "10 - 20 LPA",
  4: "20 + LPA",
};

const getRandomPercentile = (score) => {
  let min = 0;
  let max = 100;
  switch (score) {
    case 0:
      min = 0;
      max = 20;
      break;
    case 1:
      min = 20;
      max = 40;
      break;
    case 2:
      min = 40;
      max = 60;
      break;
    case 3:
      min = 60;
      max = 80;
      break;
    case 4:
      min = 80;
      max = 100;
      break;
    default:
      break;
  }
  return (100 - (Math.random() * (max - min) + min)).toFixed(1);
};

const Analysis = () => {
  const navigate = useNavigate();
  const { email } = useParams();
  const [userName, setUserName] = useState("");
  const [analysisData, setAnalysisData] = useState([]);
  const [lineChartSeries, setLineChartSeries] = useState({});
  const [score, setScore] = useState(0);
  const [dataFetching, setDataFetching] = useState(true);

  const [
    jraGetApiCall,
    { data: responseData, isLoading, isError, isSuccess, error },
  ] = useAnalysisGetMutation();

  useEffect(() => {
    jraGetApiCall({
      email: email,
    });
  }, []);

  const handleLineChartSeries = (avg_scores) => {
    const objCopy = { ...avg_scores };
    for (var subj in objCopy) {
      switch (objCopy[subj]) {
        case 3:
          objCopy[subj] = 2.5;
          break;
        case 4:
          lineChartSeries[subj] = 3;
          break;
        case 5:
          objCopy[subj] = 4;
        default:
          break;
      }
    }
    setLineChartSeries(objCopy);
  };

  useEffect(() => {
    if (isSuccess) {
      setAnalysisData(responseData.analysis);
      setUserName(responseData.name);
      setScore(responseData.score);
      handleLineChartSeries(responseData.avg_scores);
      setDataFetching(false);

      toast.success("Do not forget to scroll till the bottom. There is a surprise waiting for you at the end.", {
        autoClose: false,
        toastId: "reward",
        draggable: true,
      });
    }

    if (isError) {
      alert(error.data.error);
      navigate("/");
    }
  }, [isError, isSuccess]);

  return (
    <div>
      {dataFetching && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1000,
          }}
          open={true}
        >
          <CircularProgress color="secondary" />
        </Backdrop>
      )}

      <div className="container-fluid mt-3 mb-3">
        <nav className="navbar navbar-expand-lg  shadow-md">
          <div className="container-fluid p-2">
            <h3
              style={{
                marginRight: "auto",
                textTransform: "capitalize",
                textAlign: "center",
              }}
            >
              <a href="/" style={{ color: "#fff" }}>
                Job Ready Analysis
              </a>
            </h3>
            <Button
              href="https://linktr.ee/_o1_codingclub"
              target={"_blank"}
              rel="noopener noreferrer"
              className="mr-3"
              style={{ backgroundColor: "#6f63e6", color: "white" }}
              variant="contained"
            >
              Join Free Placement Webinar
            </Button>
            <Link className="navbar-brand text-primary mr-0" to="/">
              <img
                className="brand-logo"
                src={Logo}
                alt="O(1) Coding Club"
                srcSet=""
              />
            </Link>
          </div>
        </nav>
      </div>

      {!dataFetching && (
        <Container maxWidth="xl">
          <Grid
            container
            spacing={2}
            rowSpacing={3}
            columnSpacing={3}
            style={{ marginBottom: "5%" }}
          >
            <Grid item xs={12} sm={4} md={4}>
              <Card
                sx={{
                  boxShadow: 2,
                  minWidth: 275,
                  backgroundColor: "#6F63E6",
                }}
              >
                <CardContents className="user-detail">
                  <EmojiPeopleIcon
                    sx={{
                      boxShadow: 2,
                      fontSize: "4rem",
                      borderRadius: "2rem",
                      backgroundColor: "#7468F0",
                      padding: "0.5rem",
                      margin: "2% 0",
                    }}
                  />
                  <h2> Hi {userName} 👋</h2>
                  <p> Nice to meet you! </p>

                  <div style={{ fontSize: "large", margin: "0 0 3% 0" }}>
                    <Typewriter
                      onInit={(typewriter) => {
                        typewriter
                          .changeDelay(50)
                          .typeString("I am Lucy, the Placement Bot 🤖")
                          .pauseFor(1000)
                          .deleteAll()
                          .typeString("Let's dive into your Placement Report")
                          .pauseFor(1000)
                          .deleteAll()
                          .start();
                      }}
                      options={{ loop: true, autoStart: true }}
                    />
                  </div>

                  <Box>
                    <StyledRating
                      name="customized-color"
                      value={score}
                      precision={0.5}
                      size="large"
                      readOnly
                    />
                    <Typography component="legend" style={{ margin: "0 2%" }}>
                      Preparation Level
                    </Typography>
                  </Box>
                </CardContents>
              </Card>
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <Card
                sx={{
                  boxShadow: 2,
                  minWidth: 275,
                  backgroundColor: "#282C4B",
                }}
              >
                <CardContents
                  sx={{
                    minHeight: "12rem",
                    maxHeight: "12rem",
                    backgroundColor: "#4267FF",
                  }}
                >
                  <Grid container spacing={2} style={{ padding: "5%" }}>
                    <Grid item xs={9} sm={9} md={9}>
                      <h6>Estimated Package</h6>
                      <h1 className="mb-0">{packages[score]}</h1>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <AttachMoneyIcon
                        sx={{
                          boxShadow: 2,
                          fontSize: "4rem",
                          borderRadius: "2rem",
                          backgroundColor: "#7468F0",
                          padding: "0.5rem",
                          margin: "2% 0",
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardContents>
                <CardContents
                  sx={{
                    minHeight: "12rem",
                    maxHeight: "12rem",
                    marginTop: "1rem",
                    backgroundColor: "#4267FF",
                  }}
                >
                  <Grid container spacing={2} style={{ padding: "5%" }}>
                    <Grid item xs={9} sm={9} md={9}>
                      <h2 className="mb-0">
                        {getRandomPercentile(score)}% students
                      </h2>
                      <h6>are ahead of you</h6>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <AutoGraphIcon
                        sx={{
                          boxShadow: 2,
                          fontSize: "4rem",
                          borderRadius: "2rem",
                          backgroundColor: "#7468F0",
                          padding: "0.5rem",
                          margin: "2% 0",
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardContents>
              </Card>
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <Box>
                <Card
                  className="correct-analysis"
                  sx={{
                    boxShadow: 2,
                    minWidth: 275,
                    backgroundColor: "#10153B",
                  }}
                >
                  <CardContents>
                    <PieChart
                      PieChartLabel={Object.keys(lineChartSeries)}
                      PieChartSeries={Object.values(lineChartSeries)}
                    />
                  </CardContents>
                </Card>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <Box>
                <Card
                  className="correct-analysis"
                  sx={{
                    boxShadow: 2,
                    minWidth: 275,
                    backgroundColor: "#10153B",
                  }}
                >
                  <CardContentsMobile>
                    <CompanySlider score={score} />
                  </CardContentsMobile>
                </Card>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <Box>
                <Card
                  className="subjectWise-analysis"
                  sx={{
                    boxShadow: 2,
                    minWidth: 275,
                    backgroundColor: "#10153B",
                  }}
                >
                  <CardContentsMobile>
                    <LineGraph
                      LineGraphLabel={Object.keys(lineChartSeries)}
                      LineGraphSeries={Object.values(lineChartSeries)}
                    />
                  </CardContentsMobile>
                </Card>
              </Box>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Card
                className="subjectWise-analysis"
                sx={{
                  boxShadow: 2,
                  minWidth: 275,
                  backgroundColor: "#10153B",
                }}
              >
                <TopicAnalysis analysisData={analysisData} />
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Card
                className="subjectWise-analysis"
                sx={{
                  boxShadow: 2,
                  minWidth: 275,
                  backgroundColor: "#10153B",
                }}
              >
                <Banner data={responseData} />
              </Card>
            </Grid>
          </Grid>
          <FooterNew />
        </Container>
      )}
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="colored"
        pauseOnHover
      />
    </div>
  );
};

const StyledRating = styled(Rating)({
  "& .MuiRating-iconFilled": {
    color: "#FFD700",
  },
  "& .MuiRating-iconEmpty": {
    color: "#FFFFFF",
  },
});

export default Analysis;
